import * as ActionTypes from '../ActionTypes'
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

export const AuthorizationsISCIRReducer = (state = { 
                status: ReduxDataStatus.IDLE,
                loadTime: null,
                loadCriteria: {},
                errMess: null,
                authorizations:[]
            }, action) => {
                
    switch (action.type) {
        case ActionTypes.AUTHORIZATIONS_LOADING:
            return {...state, status: ReduxDataStatus.LOADING, errMess: null, authorizations: [], loadTime: Date.now(), loadCriteria: action.payload }

        case ActionTypes.ADD_AUTHORIZATIONS:
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, authorizations: action.payload };

        case ActionTypes.AUTHORIZATIONS_FAILED:
            return {...state, status: ReduxDataStatus.FAILED, errMess: action.payload, loadTime: null, loadCriteria: {} };

        case ActionTypes.ADD_AUTHZ:
            const nAuthorization = action.payload;
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, authorizations: state.authorizations.concat(nAuthorization) };

        case ActionTypes.UPDATE_AUTHZ:
            const uAuth = action.payload;
            const updatedAuths = state.authorizations.map(auth => auth.id === uAuth.id ? uAuth : auth );
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, authorizations: updatedAuths};

        case ActionTypes.DELETE_AUTHZ:
            const authId = action.payload;
            const filteredAuths = state.authorizations.filter(auth => auth.id !== authId);
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, authorizations: filteredAuths};

        default:
            return state;
    }
};